import React  from "react";
import { SignatureContext } from "../provider/signature";
import { Text, View } from "react-native";
import useStyles from "./styles.css";
import moment from 'moment';
import { useAppSelector } from "@src/ducks/ducksHook";
import { selectIsFreePlan } from "@src/ducks/slices/user.slice";

const ExpireReminder = () => {
  const styles = useStyles();
  const { document } = React.useContext(SignatureContext);
  const isFreePlan = useAppSelector(selectIsFreePlan);

  if (isFreePlan) {
    return null;
  }

  return (
    <View>
      <Text style={styles.body1MR}>Expiration and Reminder Options</Text>
      <Text style={[styles.body2, { marginTop: 5}]}>
        <Text style={styles.body2_bold}>Document Expiry Date: </Text> 
        {document?.workflow?.reminders?.expiration ?
          moment(document?.workflow?.reminders?.expiration).format("MM/DD/YYYY, hh:mm A")
        : 'None'}
      </Text>
      <Text style={[styles.body2, { marginTop: 5}]}>
        <Text style={styles.body2_bold}>Send Reminder Date: </Text> 
        {document?.workflow?.reminders?.expiration ?
          moment(document?.workflow?.reminders?.expiration).format("MM/DD/YYYY, hh:mm A")
        : 'None'}
      </Text>
    </View>
  );
};

export default React.memo(ExpireReminder);
